// src/redux/features/companyApi.ts

import { api } from '../services/api';

export interface CompanyCountry {
  id: number;
  label: string;
  value: string;
  value_iso3: string;
  value_numeric: string;
}

export interface Company {
  id: number;
  uf: string;

  companyname: string;

  logo?: string | null;
  stamp?: string | null;

  fiscalcode?: string | null;
  vatcode?: string | null;
  regcom?: string | null;

  countrycodelegal?: CompanyCountry | null;
  zipcodelegal?: string | null;
  citylegal?: string | null;
  addresslegal?: string | null;

  countrycodepost?: CompanyCountry | null;
  zipcodepost?: string | null;
  citypost?: string | null;
  addresspost?: string | null;

  email?: string | null;
  phone?: string | null;
  skype?: string | null;
  comment?: string | null;
}

export interface CompanyMembership {
  role: string;

  permissions: Record<string, boolean>;

  effective_permissions: Record<string, boolean>;

  is_owner: boolean;
  is_active: boolean;
}

export interface CompanySubscription {
  uf: string;

  plan: string;
  status: string;

  seats_limit: number;
  clients_limit: number;

  trial_ends_at?: string | null;

  current_period_start?: string | null;

  current_period_end?: string | null;

  cancel_at_period_end: boolean;

  created_at?: string;
  updated_at?: string;
}

export interface CompanyContext {
  company: Company;

  membership: CompanyMembership;

  subscription: CompanySubscription | null;

  can_edit_company: boolean;
}

export type UpdateCompanyPayload = Partial<Omit<Company, 'id' | 'uf'>>;

export const companyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyContext: builder.query<CompanyContext, void>({
      query: () => ({
        url: '/app/company-context/',
        method: 'GET',
      }),

      providesTags: [
        {
          type: 'Company',
          id: 'CURRENT',
        },
      ],
    }),

    updateCurrentCompany: builder.mutation<CompanyContext, UpdateCompanyPayload>({
      query: (body) => ({
        url: '/app/company-context/',
        method: 'PATCH',
        body,
      }),

      invalidatesTags: [
        {
          type: 'Company',
          id: 'CURRENT',
        },
      ],
    }),
  }),

  overrideExisting: false,
});

export const { useGetCompanyContextQuery, useUpdateCurrentCompanyMutation } = companyApi;
